<template>
  <div class="item-loading">
    <div class="skeleton-shimmer bg"></div>
    <div class="bottom">
      <div class="skeleton-shimmer text"></div>
      <div class="skeleton-shimmer btn"></div>
    </div>
  </div>
</template>

<script>
// import导入组件工具等
export default {
  name: 'LoadingItem',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.item-loading {
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  .bg {
    padding-top: 67.857%;
  }
  .bottom {
    height: 76px;
    padding: 2px 6px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
  }
  .text {
    height: 30px;
    width: 50%;
    border-radius: 12px;
  }
  .btn {
    height: 32px;
    width: 100%;
    border-radius: 16px;
  }
}
</style>
